import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=380f9cfc&scoped=true"
import script from "./InputForm.vue?vue&type=script&lang=ts"
export * from "./InputForm.vue?vue&type=script&lang=ts"
import style0 from "./InputForm.vue?vue&type=style&index=0&id=380f9cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380f9cfc",
  null
  
)

export default component.exports